var interactive = '_18teamp0';

export { interactive };
//# sourceMappingURL=swatch-button.css.js.map
